"use strict";

(function () {
  "use strict";

  angular.module("fleetviewApp").directive("alkmapsNavigation", [function () {
    var directive = {
      restrict: "AE",
      scope: {
        mapId: "@"
      },
      controllerAs: "vm",
      controller: ["$scope", "mapService", "ALKMaps", function ($scope, mapService, ALKMaps) {
        var vm = this;

        var zoomBoxControl = new ALKMaps.Control.ZoomBox({ autoActivate: false });
        var navHistoryControl = new ALKMaps.Control.NavigationHistory();

        mapService.addControl("zoomBox", zoomBoxControl);
        mapService.addControl("navHistory", navHistoryControl);

        vm.mapId = $scope.mapId;

        vm.boxZoomState = false;

        vm.isBackDisabled = function () {
          return navHistoryControl.previousStack.length <= 1;
        };

        vm.isForwardDisabled = function () {
          return navHistoryControl.nextStack.length <= 0;
        };

        vm.zoomIn = function () {
          mapService.zoomIn(vm.mapId);
        };

        vm.zoomOut = function () {
          mapService.zoomOut(vm.mapId);
        };

        vm.toggleBoxZoom = function () {
          vm.boxZoomState = !vm.boxZoomState;

          if (vm.boxZoomState) {
            zoomBoxControl.activate();
          } else {
            zoomBoxControl.deactivate();
          }
        };

        vm.goBack = function () {
          navHistoryControl.previousTrigger();
        };

        vm.goForward = function () {
          navHistoryControl.nextTrigger();
        };

        vm.goToLocation = function () {
          mapService.zoomToCurrentLocation();
        };
      }],
      template: "<div class=\"map-btns btn-group-vertical\">" + "    <button class=\"btn btn-default btn-nofocus map-btn zoom-in-btn\" ng-click=\"vm.zoomIn()\" title=\"{{'views.alkmapsNavigation.ZoomIn' | translate}}\"><i class=\"ico ico-plus\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn zoom-out-btn\" ng-click=\"vm.zoomOut()\" title=\"{{'views.alkmapsNavigation.ZoomOut' | translate}}\"><i class=\"ico ico-minus\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn zoom-box-btn\" ng-click=\"vm.toggleBoxZoom()\" title=\"{{((vm.boxZoomState)?'views.alkmapsNavigation.DragToPan':'views.alkmapsNavigation.DragToZoom') | translate}}\"><i class=\"ico\" ng-class=\"(vm.boxZoomState)?'ico-hand':'ico-box'\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn map-prev-btn\" ng-click=\"vm.goBack()\" ng-disabled=\"vm.isBackDisabled()\" title=\"{{'views.alkmapsNavigation.PreviousView' | translate}}\"><i class=\"ico ico-back\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn map-next-btn\" ng-click=\"vm.goForward()\" ng-disabled=\"vm.isForwardDisabled()\" title=\"{{'views.alkmapsNavigation.NextView' | translate}}\"><i class=\"ico ico-next\"></i></button>" + "    <button class=\"btn btn-default btn-nofocus map-btn map-loc-btn\" ng-click=\"vm.goToLocation()\" title=\"{{'views.alkmapsNavigation.ZoomToLocation' | translate}}\"><i class=\"ico ico-location-arrow\"></i></button>" + "</div>"
    };

    return directive;
  }]);
})();


// WEBPACK FOOTER //
// ./app/map/mapNavigation.directive.js